import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const HistoryCollaborationModalPreview = ({
  show,
  onCloseClick,
  data,
}: any) => {
  const [iframeLoading, setIframeLoading] = useState(true);
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!show || !data?.proofFile) return;

    setBlobUrl(null);
    setIframeLoading(true);
    setError(false);

    let localBlobUrl: string | null = null;

    fetch(data.proofFile)
      .then((res) => {
        if (!res.ok) throw new Error("Gagal fetch file");
        return res.blob();
      })
      .then((blob) => {
        const pdfBlob = new Blob([blob], { type: "application/pdf" });
        localBlobUrl = URL.createObjectURL(pdfBlob);
        setBlobUrl(localBlobUrl);
        setIframeLoading(false);
      })
      .catch(() => {
        setError(true);
        setIframeLoading(false);
      });

    return () => {
      if (localBlobUrl) URL.revokeObjectURL(localBlobUrl);
      setBlobUrl(null);
    };
  }, [show, data]);

  return (
    <Modal
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
      size="xl"
    >
      <ModalHeader className="bg-light p-3" toggle={onCloseClick}>
        <i className="ri-file-pdf-line me-2 text-danger"></i>
        Preview — <strong>{data?.proofFileName}</strong>
      </ModalHeader>

      <ModalBody className="p-0" style={{ minHeight: "600px" }}>
        {iframeLoading && (
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ height: "600px" }}
          >
            <div className="spinner-border text-primary mb-3" role="status" />
            <span className="text-muted">Memuat dokumen...</span>
          </div>
        )}

        {error && !iframeLoading && (
          <div
            className="d-flex flex-column justify-content-center align-items-center text-muted"
            style={{ height: "600px" }}
          >
            <i className="ri-error-warning-line fs-1 text-danger"></i>
            <p className="mt-2">Gagal memuat dokumen</p>
            <a
              href={data?.proofFile}
              target="_blank"
              rel="noreferrer"
              className="btn btn-soft-primary btn-sm mt-2"
            >
              <i className="ri-external-link-line me-1"></i>
              Buka di Tab Baru
            </a>
          </div>
        )}

        {blobUrl && !iframeLoading && (
          <iframe
            src={blobUrl}
            title={data?.proofFileName}
            width="100%"
            height="600px"
            style={{ border: "none" }}
          />
        )}
      </ModalBody>

      <ModalFooter>
        <a
          href={data?.proofFile}
          download={data?.proofFileName}
          target="_blank"
          rel="noreferrer"
          className="btn btn-soft-primary btn-sm"
        >
          <i className="ri-download-2-line align-bottom me-1"></i>
          Download
        </a>
        <button
          type="button"
          className="btn btn-soft-danger btn-sm"
          onClick={onCloseClick}
        >
          Tutup
        </button>
      </ModalFooter>
    </Modal>
  );
};

HistoryCollaborationModalPreview.propTypes = {
  show: PropTypes.any,
  onCloseClick: PropTypes.func,
  data: PropTypes.any,
};

export default HistoryCollaborationModalPreview;
